export default {"src":"/_next/static/media/calendar.744157e4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};